export default __webpack_public_path__ + "static/media/edit1.36e29337.svg";